package com.evoapps.evoshift.settings

import com.evoapps.evoshift.util.APP_LANGUAGES
import com.evoapps.evoshift.util.AppLocale
import kotlinx.coroutines.flow.StateFlow

/**
 * The language picked in the app (SH-137): System default (null), Polski, English or Українська.
 * Remembered on this device, so the app starts in it also before signing in; the profile keeps it
 * too (ProfileLanguageSync), so another device of the same person follows after signing in.
 * Created once per app (DI singleton): creating it applies the remembered language.
 */
class AppLanguageSettings(private val store: LocalSettings) {
    init {
        AppLocale.set(store.getString(KEY)?.takeIf { it in APP_LANGUAGES })
    }

    /** The picked language; null: the device's. */
    val preference: StateFlow<String?> = AppLocale.chosen

    /** Picks [language] (null: the device's), remembers it and switches the app to it at once. */
    fun choose(language: String?) {
        val value = language?.takeIf { it in APP_LANGUAGES }
        store.putString(KEY, value)
        if (value != AppLocale.chosen.value) AppLocale.set(value)
    }

    companion object {
        const val KEY = "appLanguage"
    }
}
